import http from "@/utils/http";
import VueCookie from "vue-cookie";

const state = {
  userInfo: {
    roles: [
      {
        code: "",
      },
    ],
  },
};

// getters
const getters = {};

// mutations
const mutations = {
  change_user(state, newUser) {
    state.userInfo = newUser;
  },
};

// actions
const actions = {
  get_user({ commit }) {
    return http.get("api-admin/users/getLoginUser", {}).then((res) => {
      if (res.code === 0) {
        localStorage.setItem("sysEntMenus", JSON.stringify(res.data.sysMenus));
        commit("change_user", res.data);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
